export default __webpack_public_path__ + "static/image6-774c7f02132e28df6f6b5d9654a703c3.jpg";